// extracted by mini-css-extract-plugin
module.exports = {"preSale":"preSale_preSale__ZLH84","desc":"preSale_desc___lBmx","countdown":"preSale_countdown__c98jr","presaleText":"preSale_presaleText__AdCyc"};